import React from 'react';
import NEETPGPredictor from './components/NEETPGPredictor';

function App() {
  return (
    <div className="App">
      <NEETPGPredictor />
    </div>
  );
}

export default App; 